import { Box, type Colors, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'
import { F0AvatarPerson } from '@factorialco/f0-react'
import { ContractsEmployeesEmployeeFragment } from 'generated/resources/graphql'

import type ContractFlow from 'modules/contracts/lib/ContractFlow'

interface Props {
  employee: ContractsEmployeesEmployeeFragment
  flow: ContractFlow
  title: string
  background?: Colors
  onClose: () => void
}

const Header = ({ employee, flow, background, title, onClose }: Props) => {
  const onCloseClick = () => {
    flow.trackExit()
    onClose()
  }
  return (
    <Box
      width="full"
      height="s64"
      flexDirection="row"
      gap="s4"
      background={background || 'grey000White'}
      justifyContent="center"
      alignItems="center"
      border={{
        bottom: {
          width: 's2',
          color: 'grey300',
          style: 'solid',
        },
      }}
    >
      <F0AvatarPerson
        firstName={employee.firstName}
        lastName={employee.lastName}
        src={employee.avatar?.url}
        size="medium"
      />
      <Text.Normal weight="semibold" size="300">
        {title}
      </Text.Normal>
      <Box
        width="s32"
        height="s32"
        justifyContent="center"
        alignItems="center"
        border={{
          all: {
            width: 's2',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs100',
        }}
        style={{ position: 'absolute', right: '18px' }}
      >
        <Touchable onClick={() => onCloseClick()}>
          <Icon.Medium icon="cross" />
        </Touchable>
      </Box>
    </Box>
  )
}

export default Header
